import React from 'react';
import { AudioLines } from 'lucide-react';
import OpusConverter from '../components/OpusConverter';
import { useTranslation } from 'react-i18next';
import { SEO, SITE_URL, breadcrumbJsonLd } from '../components/SEO';

const OpusConverterPage: React.FC = () => {
  const { t } = useTranslation();
  const description = 'Convert audio and video to 16 kHz mono Opus in your browser for speech recognition and transcription workflows. No upload required.';

  return (
    <section className="py-16 bg-slate-50/60 dark:bg-zinc-900/40 min-h-[calc(100vh-4rem)] transition-colors duration-300">
      <SEO
        title="Free Opus Converter for Transcription | OmniScribe"
        description={description}
        path="/tools/opus-converter"
        keywords={[
          'Opus converter',
          'convert audio to Opus',
          'video to Opus',
          '16kHz mono Opus',
          'speech recognition audio converter',
          'transcription audio converter',
        ]}
        jsonLd={[
          breadcrumbJsonLd([
            { name: 'Home', path: '/' },
            { name: 'Opus Converter', path: '/tools/opus-converter' },
          ]),
          {
            '@context': 'https://schema.org',
            '@type': 'WebApplication',
            name: 'OmniScribe Opus Converter',
            url: `${SITE_URL}/tools/opus-converter`,
            applicationCategory: 'MultimediaApplication',
            operatingSystem: 'Web',
            description,
            offers: {
              '@type': 'Offer',
              price: '0',
              priceCurrency: 'USD',
            },
          },
        ]}
      />
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/80 dark:bg-zinc-900/70 backdrop-blur-sm text-indigo-700 text-sm font-medium mb-6 border border-indigo-100 dark:text-indigo-300 dark:border-indigo-500/20 shadow-sm">
            <AudioLines className="h-4 w-4" />
            {t('tools.badge')}
          </div>
          <h1 className="h-section mb-4">{t('tools.opusConverter.title')}</h1>
          <p className="text-slate-600 dark:text-zinc-400 leading-relaxed">
            {t('tools.opusConverter.description')}
          </p>
        </div>

        <OpusConverter />
      </div>
    </section>
  );
};

export default OpusConverterPage;
